import { AccessAudit } from './AccessAudit';
import { AccessComparison } from './AccessComparison';
import { AccessExplainer } from './AccessExplainer';
import { DataAccess } from './DataAccess';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { FeatureRouteWrapper } from '@ui/features';
import React from 'react';
import { ViewArea } from '@ui/general';
import { BASE_ROUTES, PARAMS } from '@sonar-software/sonar-ts-constants';
import { Route, Routes } from 'react-router';
export const DataAccessView = () => React.createElement(ViewArea, { collapseSidebar: true, direction: 'horizontal', fullWidth: true, id: 'data-access-view-area' },
    React.createElement(Routes, null,
        React.createElement(Route, { element: React.createElement(FeatureRouteWrapper, { feature: FeatureFlag.AccessAudit },
                React.createElement(AccessAudit, null)), path: `${BASE_ROUTES.ACCESS_AUDIT}/${PARAMS.ID}` }),
        React.createElement(Route, { element: React.createElement(FeatureRouteWrapper, { feature: FeatureFlag.AccessExplainer },
                React.createElement(AccessExplainer, null)), path: `${BASE_ROUTES.ACCESS_EXPLAINER}/${PARAMS.ID}?*` }),
        React.createElement(Route, { element: React.createElement(FeatureRouteWrapper, { feature: FeatureFlag.AccessComparison },
                React.createElement(AccessComparison, null)), path: `${BASE_ROUTES.ACCESS_COMPARISON}` }),
        React.createElement(Route, { element: React.createElement(DataAccess, null), path: '*' })));
